<template>
  <div class="teacher-comments">
    <h4 class="title-section">{{ title }}</h4>
        <table>
            <tr>
                <th style="width: 10%">Lần</th>
                <th style="width: 20%">Ngày nhận xét</th>
                <th style="width: 70%">Nội dung nhận xét</th>
            </tr>
            <tr v-for="comment,index in teacherCommentsData" :key="'comment-teacher-' + index">
                <td>{{comment['Lần'] ? comment['Lần'] : ''}}</td>
                <td>{{comment['Ngày nhận xét'] ? formatDate(comment['Ngày nhận xét']) : ''}}</td>
                <td>{{comment['Nội dung nhận xét'] ? comment['Nội dung nhận xét'] : ''}}</td>
            </tr>
        </table>
  </div>
</template>

<script>
export default {
  name: 'TeacherComments',
  props:['teacherCommentsData', 'title'],
  components: {},
  data() {
    return {}
  },
  watch: {
  },
  created() {
  },
  methods: {
    formatDate(dateString){
        let date = new Date(dateString);
        var month = date.getUTCMonth() + 1; //months from 1-12
        var day = date.getUTCDate();
        var year = date.getUTCFullYear();
        let newdate = day + "/" + month + "/" + year;
        return newdate
    },
  }
}
</script>

<style>
</style>